import React, { useState } from 'react'
import './CollectibleItemA.scss'
import CollectibleDTO from '../../DTO/CollectibleDTO'
// import PageElementDTO from '../../DTO/PageElementDTO'
// import { ShoppingBag, Plus } from 'react-feather'
import mainservice from '../../services/MainService'
import './CollectibleItemA.scss'
import { Flip, Source, Remove, BookmarkAdd, BookmarkSubtract, Share } from '../Icon/Icon'
import Tooltip from '../Tooltip/Tooltip'

// import QRCode from 'qrcode.react'
// var QRCode = require('qrcode.react');
import {QRCodeSVG} from 'qrcode.react';

enum Status {
  standard,
  chooseCollectible,
  showMore
}

type Props = {
  collectible: CollectibleDTO,
  onClick?: (id: number) => void,
  className?: string,
  singleMode?: boolean
}

export default function CollectibleItemC(props: Props) {
  const [status, setStatus] = useState(Status.standard)
  const [removed, setRemoved] = useState(false)
  const [showCopyToClipboardNotice, setShowCopyToClipboardNotice] = useState(false)
  const [qrCodeInverter, setQrCodeInverter] = useState(true)
  const [showCopyToClipboardNoticeTimer, setShowCopyToClipboardNoticeTimer] = useState<number | null>(null)

  function generateClassName() {
    if (props.className !== undefined) {
      return props.className
    }
    return 'show w3-col s12 m6 l4 xl3 collectibleId-' + props.collectible.id
  }

  function copyToClipBoard(link: string) {
    if (showCopyToClipboardNoticeTimer) {
      clearTimeout(showCopyToClipboardNoticeTimer)
    }
    navigator.clipboard.writeText(link);
    setShowCopyToClipboardNotice(true)
    setShowCopyToClipboardNoticeTimer(window.setTimeout(() => {
      setShowCopyToClipboardNotice(false)
    }, 1000))
  }

  function getDirectLink() {
    return `https://${window.location.hostname}/view=collectible/uid=${props.collectible.uid}`
  }

  function renderToggleMoreButton() {
    return <div
      className={`toggleMore pointer`}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        setStatus(status === Status.showMore ? Status.standard : Status.showMore)
      }}
    ><Flip /></div>
  }

  function renderButtons() {
    const c = props.collectible
    return <div className='optionbox-bottom-right'>
      {
        [
          {
            title: 'Gehe zu Quelle',
            onClick: () => {
              mainservice.navTo([
                ['view', 'book'],
                ['book', c.sourceBookId],
                ['doublePageId', c.sourceDoublePageId]
              ])
            },
            content: <Source />,
            condition: () => {
              return c.sourceBookId && c.sourceBookId > -1 &&
                c.sourceDoublePageId && c.sourceDoublePageId > -1
            }
          },
          {
            title: 'Aus Sammlung entfernen',
            onClick: async () => {
              await c.ditch(mainservice.loginService.user.id)
              // TODO this.forceUpdate()
            },
            content: <BookmarkSubtract />,
            condition: () => c.collected
          },
          {
            title: 'Einloggen um zur Sammlung hinzuzufügen',
            onClick: async () => {
              mainservice.broadcast('showLogin', true)
            },
            content: <BookmarkAdd />,
            condition: () => !c.collected && !mainservice.loginService.instantIsLoggedIn()
          },
          {
            title: 'Zu Sammlung hinzufügen',
            onClick: async () => {
              await c.collect({bookId: -1, doublePageId: -1})
              // TODO this.forceUpdate()
            },
            content: <BookmarkAdd />,
            condition: () => !c.collected && mainservice.loginService.instantIsLoggedIn()
          },
          {
            title: 'Kopiere Link in Zwischenablage',
            onClick: () => {copyToClipBoard(getDirectLink())},
            content: <>
              <Share />
              { showCopyToClipboardNotice &&
                <Tooltip content={`Link in Zwischenablage kopiert`} />
              }
            </>,
            condition: () => true
          },
          /*
          {
            title: 'Direkt Link',
            onClick: () => {},
            content: <a href={this.getDirectLink()}><ArrowRight /></a>
          }
          */
        ].map((e, i) => {
          if (!e.condition()) { return null }
          return <button
          key={i}
          onClick={() => {e.onClick()}}
          >
          <Tooltip content={e.title} />
          { e.content }
          </button>
        }
        )
      }
    </div>
  }


  const c = props.collectible
    if (!c || removed) { return null }

    return <div className={`${generateClassName()}`}>
      <div className={`collectible-box ${status === Status.showMore ? 'showMore' : 'dontShowMore'}`}>
        <div
          onClick={() => {
            if (props.onClick) {
              props.onClick(c.id)
            }
          }}
          className={`collectibleItemInner collectible-content collectible-type-${c.type}`}
        >
          <div className='cardTypeString'>{c.typeName()}</div>
          <div
            className='cardContentFullSize'
            dangerouslySetInnerHTML={{__html: c.getContent()}}
            // style={{backgroundImage: `url("data:image/svg+xml;utf8,${c.content}")`}}
          >
          </div>
          { !props.singleMode && renderToggleMoreButton() }
        </div>
        <div className={`collectibleMore`}>
          <Remove
            onClick={() => {
              setStatus(Status.standard)
            }}
            className='closeButton'
          />
          <div className='title'>{c.title}</div>
          <QRCodeSVG
            className='qrCode'
            onClick={() => {
              setQrCodeInverter(!qrCodeInverter)
            }}
            value={getDirectLink()}
            width='500'
            height='500'
            fgColor={qrCodeInverter ? '#ffffff' : '#272d2f'}
            bgColor={qrCodeInverter ? '#272d2f' : '#ffffff'}
          />
          { renderButtons() }
        </div>
      </div>
      { props.singleMode && renderButtons() }
    </div>

}
